import PageMeta from "@/components/common/PageMeta";
import PageBreadcrumb from "@/components/common/PageBreadCrumb";
import QRProfileSection from "./QRProfileSection";

export default function QRProfilePage() {
  return (
    <>
      <PageMeta title="QR Code | Poultry Book" description="Manage farm QR code" />
      <PageBreadcrumb pageTitle="QR Code" />

      <div className="mx-auto max-w-2xl card p-5 sm:p-8">
        <h3 className="mb-5 text-lg font-semibold text-gray-800 dark:text-white/90">
          QR Code
        </h3>
        <QRProfileSection />
      </div>
    </>
  );
}
